
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-shopping-experience",
      function () {
        return require("private-next-pages/live-shopping-experience/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-shopping-experience"])
      });
    }
  